'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _omitBy = require('lodash/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _mapDataPayloadToContextPayload = require('./map-data-payload-to-context-payload');

var _mapDataPayloadToContextPayload2 = _interopRequireDefault(_mapDataPayloadToContextPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    var sourceName = props.sourceName,
        sourceType = props.sourceType,
        componentName = props.componentName,
        other = (0, _objectWithoutProperties3.default)(props, ['sourceName', 'sourceType', 'componentName']);

    var validProps = (0, _mapDataPayloadToContextPayload2.default)(other);
    var source = sourceName && sourceType ? '' + sourceName + sourceType : undefined;

    return (0, _omitBy2.default)((0, _extends3.default)({
        componentName: componentName,
        source: source
    }, validProps), _isUndefined2.default);
};